import React from "react"
import { SelectField, MenuItem } from "material-ui"
import { ERecordSearchFilter } from "../../models"
import strings from "../../localization/strings"
interface IProps {
    readonly: boolean
    selectedFilter: ERecordSearchFilter
    handleChange(selectedFilter: ERecordSearchFilter): void
}

const RecordFilterSelector: React.SFC<IProps> = (props: IProps) => {
    return (
        <SelectField
            disabled={props.readonly}
            floatingLabelText={strings.Filter}
            value={props.selectedFilter}
            onChange={(e, key, selectedFilter) => props.handleChange(selectedFilter)}
            style={{ width: 200 }}
        >
            <MenuItem value={ERecordSearchFilter.All} primaryText={strings.All} />
            <MenuItem value={ERecordSearchFilter.BioExceptions} primaryText={strings.Biometric_Exception} />
            <MenuItem value={ERecordSearchFilter.LocExceptions} primaryText={strings.Location_Exception} />
            <MenuItem value={ERecordSearchFilter.SuspensePunches} primaryText={strings.Suspense_Punches} />
        </SelectField>
    )
}

export default RecordFilterSelector